import { render, staticRenderFns } from "./SchoolHourPriceEdit.vue?vue&type=template&id=2420ad08&"
import script from "./SchoolHourPriceEdit.vue?vue&type=script&lang=js&"
export * from "./SchoolHourPriceEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchoolHourPriceEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports